
import { Component, Mixins } from "vue-property-decorator";
import { IDrawableItem, IArrowDrawable, instanceOfIArrowDrawable, instanceOfILineDrawable } from "../../../../../domain/document/items";
import { ArrowKinds, LineKinds } from "../../../../../domain/drawing";
import { IDrawableItemEditable } from "../../IDrawableItemEditable";

@Component({
})
export default class ArrowDrawerPropertyEditableMixin extends Mixins() implements IDrawableItemEditable {
  editingSource: IDrawableItem;
  writeProperty: (write: (source: IArrowDrawable) => void) => void;

  get arrowKind(): ArrowKinds {
    return instanceOfIArrowDrawable(this.editingSource)
      ? this.editingSource.arrowKind
      : undefined;
  }

  set arrowKind(value: ArrowKinds) {
    this.writeProperty(s => {
      s.arrowKind = value;
      if (value !== ArrowKinds.None && instanceOfILineDrawable(s)) {
        s.lineStyle.kind = LineKinds.Normal;
      }
    });
  }

  get isArrow(): boolean {
    if (!instanceOfIArrowDrawable(this.editingSource)) { return false; }
    return (this.editingSource.arrowKind !== ArrowKinds.None);
  }
}
